import { Component, Input, ElementRef } from '@angular/core';
import { TreeNode } from '../../primeng_components/common/treenode';

@Component({
    selector: 'al-panel-treeview',
    template: `
        <div class="al-panelTreeview-wrapper">
            <div *ngIf="TreeControlVisible" class="al-panelTreeview-controls clearfix">
                <a href="javaScript:void(0)" [title]="expandAllTitle" (click)="expandAllTreeviewNodes()">{{expandAllText}}</a>
                <span>|</span>
                <a href="javaScript:void(0)" [title]="collapseAllTitle" (click)="collapseAllTreeviewNodes()">{{collapseAllText}}</a>
            </div>

            <p-tree [value]="value" (onNodeExpand)="showTreeChild();" (onNodeCollapse)="hideTreeChild();"></p-tree>
        </div>
        `
})

export class AlPanelTreeviewComponent {

    // set collection of value for create paneltreeview
    @Input() value: any;

    // set treeRef
    @Input() treeRef: any;

    // set paneltreeview controls visible
    @Input() TreeControlVisible: boolean = true;

    // set Expand all contorl text, default is Expand all
    @Input() expandAllText: string = 'Expand all';

    // Set Expand all contorl title attribute value, default is Expand all
    @Input() expandAllTitle: string = 'Click here to expand all views';

    // set collapse all contorl text, default is Expand all
    @Input() collapseAllText: string = 'Collapse all';

    // set collapse all contorl title attribute value, default is Expand all
    @Input() collapseAllTitle: string = 'Click here to collapse all views';

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     *
     */
    constructor(private _element: ElementRef) { }

    /**
     * expand all treeview nodes
     * set accessibility attributes, aria-hidden, aria-labelledby, role, tabindex
     *
     * @method expandAllTreeviewNodes
     *
     */
    expandAllTreeviewNodes() {
        this.value.forEach(node => {
            this.expandRecursive(node, true);
        });

        this._element.nativeElement.querySelector('.ui-treenode').setAttribute('aria-hidden', 'true');
        this._element.nativeElement.querySelector('.ui-treenode').setAttribute('aria-labelledby', 'Treeview Header');
        this._element.nativeElement.querySelector('.ui-treenode').setAttribute('role', 'Treeview');
        this._element.nativeElement.querySelector('.ui-treenode').setAttribute('tabindex', '0');
    }

    /**
     * collapse all treeview nodes
     * change accessibility attributes, aria-hidden
     *
     * @method collapseAllTreeviewNodes
     *
     */
    collapseAllTreeviewNodes() {
        this.value.forEach(node => {
            this.expandRecursive(node, false);
        });
        this._element.nativeElement.querySelector('.ui-treenode').setAttribute('aria-hidden', 'false');
    }

    /**
     * expandRecursive function will check if child nodes are available, and based on that, expand and collapse child nodes
     *
     * @method expandRecursive
     * @param node
     * @param isExpand
     *
     */
    expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        /* istanbul ignore if */
        if (node.children) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    /**
     * show tree child nodes
     * set accessibility attributes, aria-hidden, aria-labelledby, role, tabindex
     *
     * @method showTreeChild
     *
     */
    showTreeChild() {
        let allNode = document.querySelectorAll('.ui-treenode-content > .ui-tree-toggler');
        [].forEach.call(allNode, function (ele) {
            ele.setAttribute('aria-hidden', 'false');
            ele.setAttribute('aria-labelledby', 'Treeview Header');
            ele.setAttribute('role', 'Treeview');
            ele.setAttribute('tabindex', '0');
        });
    }

    /**
     * hdie tree child nodes
     * change accessibility attributes, aria-hidden
     *
     * @method hideTreeChild
     *
     */
    hideTreeChild() {
        let allNode = document.querySelectorAll('.ui-treenode-content > .ui-tree-toggler');
        [].forEach.call(allNode, function(ele) {
            ele.setAttribute('aria-hidden', 'True');
        });
    }

}
